import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { Locations, Product, NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import { trackNavigationClick } from '../events'

export const OnCallLink = ({
  className = '',
  location = Locations.NAVIGATION,
  product = Product.ON_CALL,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
  product?: (typeof Product)[keyof typeof Product]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.onCall')

  const handleOnCallClick = () => {
    trackNavigationClick(
      ctaCopy,
      NavigationEvents.LEVELS.PRIMARY,
      location,
      product,
    )
  }

  return (
    <Link
      href={paths.onCall}
      className={`mc-ml-4 ${className}`}
      onClick={handleOnCallClick}
      passHref
      newTab
    >
      {ctaCopy}
    </Link>
  )
}
